import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [business, setBusiness] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  // Admin impersonation: business being viewed
  const [impersonating, setImpersonating] = useState(null);

  const checkAuth = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data.user);
      setBusiness(res.data.business);
      setIsAdmin(res.data.is_admin);
    } catch (e) {
      setUser(null);
      setBusiness(null);
      setIsAdmin(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: skip /me if returning from OAuth callback; AuthCallback handles it.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setUser(null);
    setBusiness(null);
    setIsAdmin(false);
    setImpersonating(null);
    window.location.href = "/";
  };

  // effective business id for API calls (admin impersonation aware)
  const effectiveBusinessId = isAdmin ? impersonating?.business_id : business?.business_id;

  return (
    <AuthContext.Provider value={{
      user, business, isAdmin, loading, checkAuth, setUser, setBusiness, setIsAdmin,
      logout, impersonating, setImpersonating, effectiveBusinessId,
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
